export default defineNuxtPlugin(() => {
    const router = useRouter();
    const route = useRoute();

    // List of UTM parameters to preserve
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

    // Helper function to extract UTM parameters from current route
    const getUTMParams = () => {
        const params = {};
        utmParams.forEach(param => {
            if (route.query[param]) {
                params[param] = route.query[param];
            }
        });
        return params;
    };

    // Helper function to merge UTM parameters with a URL
    const addUTMToUrl = (to) => {
        const utmQuery = getUTMParams();
        
        // If no UTM parameters, return original
        if (Object.keys(utmQuery).length === 0) {
            return to;
        }

        // Handle string URLs
        if (typeof to === 'string') {
            const url = new URL(to, window.location.origin);
            
            // Add UTM parameters that don't already exist
            Object.entries(utmQuery).forEach(([key, value]) => {
                if (!url.searchParams.has(key)) {
                    url.searchParams.set(key, value);
                }
            });
            
            return url.pathname + url.search + url.hash;
        }

        // Handle route location objects
        if (typeof to === 'object' && to !== null) {
            return {
                ...to,
                query: {
                    ...utmQuery,
                    ...(to.query || {}), // Existing query params take precedence
                }
            };
        }

        return to;
    };

    // Intercept router.push
    const originalPush = router.push;
    router.push = function(to) {
        return originalPush.call(this, addUTMToUrl(to));
    };

    // Intercept router.replace
    const originalReplace = router.replace;
    router.replace = function(to) {
        return originalReplace.call(this, addUTMToUrl(to));
    };

    // Provide helper function for manual use
    return {
        provide: {
            preserveUTM: addUTMToUrl,
            getUTMParams,
        }
    };
});
